import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import StepControlButton, {CONTROL_NEXT, CONTROL_PREV} from "../../components/navigation/StepControlButton";
import {isProductChangeStepValid} from "../../selectors/StepValidation";
import {getAppMode} from "../../selectors/Mode";
import {APP_MODE_AGENCYSERVER_ADD_PROJECT, APP_MODE_REGULAR, ARTICLE_CONFIGURATOR_MODE_CONSUMER_SELECTION, ARTICLE_CONFIGURATOR_MODE_SHARED} from "../../constants/General";
import PriceListingRow from "../../components/PriceListingRow";
import {getCurrentProduct, getSelectedArticle} from "../../selectors/ProductSelection";
import {getArticleOptionsData, getContracts} from "../../selectors/SimpleSelectors";
import {delve} from "../../util/util";
import {forceValidationOnSteps} from "../../actions/StepControl";
import {agencyServerProjectArticles} from "../../config/Config";
import ArticleConfigurator from "../configuration/configurator/ArticleConfigurator";
import HintWrapper from "../../components/HintWrapper";
import FadingTransitionGroup from "../../components/FadingTransitionGroup";
import {_contract} from "../../selectors/GetParam";
import ToggleButton, {THEME_BLOCK_DESCRIPTION} from "../../components/ToggleButton";
import {faServer} from "@fortawesome/pro-light-svg-icons/faServer";
import * as StepLabels from "../../constants/StepLabels";
import StepValidationErrors from "../../components/StepValidationErrors";

function mapStateToProps(state) {

    const contracts = getContracts(state)
    const contract = contracts ? contracts[_contract] : null;
    const isLegacyResellerContract = (delve(contract, "sourceType") === "RESELLER" && parseInt(delve(contract, "article.articleNumber")) < 70000);

    // check if account is old package like webhosting (type vserver)
    const isLegacyProduct = parseInt(getCurrentProduct(state), 10) < 70000;

    return {
        isFetching: state.cart && state.cart.isFetching,
        cartIsSwapping: state.cart && state.cart.isSwapping,
        cartIsSwappingProgress: state.cart && state.cart.isSwappingProgress,
        productChangeStepValid: isProductChangeStepValid(state),
        currentProduct: getCurrentProduct(state),
        selectedProduct: getSelectedArticle(state),
        articleOptions: getArticleOptionsData(state),
        contracts: getContracts(state),
        contract: contract,
        forcedValidationSteps: state.ui.forcedValidationSteps,
        isLegacyResellerContract,
        isLegacyProduct,
        currentAccount: delve(contracts, _contract + ".sourceUid"),
        nextContractDurationDate: contracts[_contract] && contracts[_contract].nextContractDurationDate,
        mode: getAppMode()
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        forceValidation: () => {
            dispatch(forceValidationOnSteps([ownProps.stepLabel]))
        }
    };
}

class ProductChangeStep extends Component {

    handleButtonNextClick = (e) => {
        if (this.props.productChangeStepValid === true) {
            this.props.onButtonNextClick()
        } else  {
            this.props.forceValidation()
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps.cartIsSwappingProgress) {
            return false
        }
        return true
    }

    render() {

        const {currentProduct, mode, articleOptions, prevLabel, nextLabel, productChangeStepValid, onButtonPrevClick, selectedProduct, isLegacyResellerContract} = this.props
        const isAgencyServerArticle = agencyServerProjectArticles.indexOf("" + currentProduct) >= 0

        let content;

        if (isAgencyServerArticle) {

            content = (
                <Fragment>
                    <h2>Konfiguriere dein Projekt</h2>
                    <ArticleConfigurator
                        mode={ARTICLE_CONFIGURATOR_MODE_SHARED}
                        currentProduct={currentProduct}
                        updateSelectedArticle={true}
                        hidePersonalization={!(mode === APP_MODE_REGULAR || mode === APP_MODE_AGENCYSERVER_ADD_PROJECT)}
                    />
                    <FadingTransitionGroup>
                        {
                            selectedProduct !== currentProduct && delve(articleOptions, selectedProduct + ".price.default.net") < delve(articleOptions, currentProduct + ".price.default.net") ?
                                <HintWrapper
                                    content={"Ein Wechsel zu einem günstigerem Tarif ist frühestens zum " + new Date(this.props.nextContractDurationDate * 1000).toLocaleDateString("de-DE", {day: "2-digit", month: "2-digit", year: "numeric"}) + " möglich."}
                                    theme={"blue"}/>
                                : null}
                    </FadingTransitionGroup>
                </Fragment>
            )

        } else if (isLegacyResellerContract) {

            content = (
                <Fragment>
                    <h2>Wähle deinen neuen Tarif</h2>
                    <p>Eine Umstellung deines Servers auf den neuen Agentur-Server erfolgt in mehreren Schritten. Buche zunächst den Agentur-Server als Basis für deine Projekte und gliedere dann die Projekte aus deinem Server auf den Agentur-Server aus. Alternativ kannst du deinen aktuellen Server
                        auch behalten und mit den nächsten Projekten auf dem Agentur-Server beginnen oder einzelne Projekte auf den Agentur-Server ausgliedern.</p>
                    <ToggleButton
                        icon={faServer}
                        onClick={() => {
                        }}
                        className={"active"}
                        target={""}
                        selected={true}
                        buttonLabel="Agentur-Server"
                        theme={THEME_BLOCK_DESCRIPTION}
                        description="Das digitale Zuhause für deine Projekte. Verwalte alles unter einem Dach."
                        hint={"ab 10.00 € mtl.*"}
                    />
                </Fragment>
            )

        } else {

            content = (
                <Fragment>
                    <h2>Wähle deinen neuen Tarif</h2>
                    <ArticleConfigurator
                        mode={ARTICLE_CONFIGURATOR_MODE_CONSUMER_SELECTION}
                        currentProduct={currentProduct}
                        updateSelectedArticle={true}
                        hidePersonalization={true}
                    />
                    <FadingTransitionGroup>
                        {
                            selectedProduct !== currentProduct && delve(articleOptions, selectedProduct + ".price.default.net") < delve(articleOptions, currentProduct + ".price.default.net") ?
                                <HintWrapper
                                    content={"Ein Wechsel zu einem günstigerem Tarif ist frühestens zum " + new Date(this.props.nextContractDurationDate * 1000).toLocaleDateString("de-DE", {day: "2-digit", month: "2-digit", year: "numeric"}) + " möglich."}
                                    theme={"blue"}/>
                                : null}
                    </FadingTransitionGroup>
                </Fragment>
            )

        }


        return (
            <div className="step-display__page productchange-step">

                <StepValidationErrors
                    validationResult={this.props.productChangeStepValid}
                    stepLabel={StepLabels.PRODUCT_CHANGE}
                />

                <h1>Dein aktueller Tarif</h1>

                {currentProduct ? <PriceListingRow
                    title={delve(articleOptions, currentProduct + ".title")}
                    caption={delve(articleOptions, currentProduct + ".description")}
                    price={Number(this.props.contract ? delve(this.props.contract, 'contractPrice') : delve(articleOptions, currentProduct + ".price.default.net")).toFixed(2) + " € mtl."}
                    tax={true}
                /> : null}

                {content}
                <div className="step-display__page__control">
                    {prevLabel !== "" ? <StepControlButton type={CONTROL_PREV} label={prevLabel} onClick={onButtonPrevClick}/> : null}
                    {nextLabel !== "" ? <StepControlButton disabled={productChangeStepValid !== true} type={CONTROL_NEXT} label={nextLabel} onClick={this.handleButtonNextClick}/> : null}
                </div>

            </div>
        );
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ProductChangeStep);



/** WEBPACK FOOTER **
 ** ./src/containers/productselection/ProductChangeStep.js
 **/